import { Checkbox as MuiCheckbox } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const Checkbox = styled(MuiCheckbox)`
  ${({ theme }) => css`
    color: ${theme.colors.primary} !important;
    width: 18px !important;
    height: 18px !important;

    &:hover {
      background: none;
    }

    .MuiSvgIcon-root {
      font-size: 24px !important;
      width: 24px !important;
      height: 24px !important;
    }

    &.Mui-checked {
      width: 18px !important;
      height: 18px !important;
      color: ${theme.colors.primary} !important;
    }

    &.Mui-disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:not(.Mui-checked) {
      .MuiSvgIcon-root {
        width: 18px !important;
        height: 18px !important;
        color: transparent !important;
        border: 2px solid ${theme.colors.gray[400]} !important;
        border-radius: 2px;
        background-color: transparent;
      }
    }
  `}
`

export const Label = styled.label`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: -0.28px;
    margin-top: 1px;
    cursor: pointer;
    user-select: none;

    &:hover {
      transition: all 0.3s ease;
      filter: brightness(0.95);
    }
  `}
`
